module.exports = __webpack_public_path__ + "media/images/zsenieLogoSmall-1b962b38.png";